(function () {
    'use strict';

    function main() {
        const controller = {
            init: function () {
                const widgets = wo$('[data-widget-type="mobile-phone-Product"]');
                if (!widgets.length) return;

                widgets.off('click');
                widgets.on('click', '#view-full-details', function () {
                    WhistleOut.trackEvent('MobileProduct', 'ViewFullDetails');
                });
                widgets.on('click', '[data-transaction]', function () {
                    const $this = wo$(this); // eslint-disable-line  @typescript-eslint/no-invalid-this
                    const transaction = $this.data('transaction');
                    const supplier = $this.data('supplier');

                    WhistleOut.appendReferrer($this);
                    WhistleOut.trackEvent('MobileProduct', transaction, supplier);
                });
                widgets.on('click', '[data-view-supplier]', function () {
                    WhistleOut.trackEvent(
                        'MobilePhone',
                        'ViewSupplier',
                        wo$(this).data('view-supplier') // eslint-disable-line  @typescript-eslint/no-invalid-this
                    );
                });
            }
        };

        WhistleOut.initWidget = controller.init;
        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
}());
